// extracted by mini-css-extract-plugin
module.exports = {"efficiency":"EfficiencyPanel_efficiency__KDWcF","efficiency__saving":"EfficiencyPanel_efficiency__saving__x04jE","efficiency__heading":"EfficiencyPanel_efficiency__heading__60PAg"};